/* AGENT_PORTAL_UI_CLEANUP_V6 — keep admin agency switching reachable + mobile containment. */
(function(){
  if(window.__admetecUiCleanupV6)return;
  window.__admetecUiCleanupV6=true;

  function ensureStyles(){
    if(document.getElementById('AgentPortalUiCleanupV6Styles'))return;
    var style=document.createElement('style');
    style.id='AgentPortalUiCleanupV6Styles';
    style.textContent=`
.agent-portal__agency-card{display:none!important}
[data-history-complete-badge],[data-hr]{display:none!important}
.agent-portal__action-row-v3{display:grid;grid-template-columns:auto auto minmax(0,1fr) auto;gap:12px;align-items:center;margin-top:18px}
.agent-portal__action-row-v3>.agent-portal__draft-bar{display:contents!important}
.agent-portal__action-row-v3 .agent-portal__draft-status{grid-column:1/-1;grid-row:2;margin:0;text-align:left}
.agent-portal__action-row-v3>.agent-portal__actions{grid-column:4;grid-row:1;display:flex;align-items:center;justify-content:flex-end;gap:10px;margin:0!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-tools{display:grid!important;grid-template-columns:minmax(180px,.7fr) minmax(320px,1.3fr)!important;align-items:center!important;justify-content:space-between!important;gap:18px!important;min-height:0!important;padding:14px 18px!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-tools-copy{min-width:0!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-tools-copy .agent-portal__kicker{font-size:1.05rem!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-tools-copy>strong{margin:3px 0 0!important;font-size:1.65rem!important;line-height:1.15!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-tools-copy p{display:none!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-view-control{display:flex!important;flex-direction:column!important;gap:6px!important;min-width:0!important;width:100%!important;padding:0!important;border:0!important;background:transparent!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-view-control>label{display:block!important;color:#5f5855!important;font-size:1.08rem!important;font-weight:800!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-view-actions{display:grid!important;grid-template-columns:minmax(220px,1fr) auto!important;gap:10px!important;align-items:stretch!important;min-width:0!important;width:100%!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-view-actions select{display:block!important;width:100%!important;min-width:0!important;max-width:100%!important}
.agent-portal.agent-portal--agency-preview .agent-portal__admin-return{display:inline-flex!important;width:auto!important;min-width:0!important;max-width:100%!important;white-space:nowrap!important}
.agent-portal.agent-portal--agency-preview .agent-portal__tabs.agent-portal__tabs--admin{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;grid-auto-flow:initial!important;grid-auto-columns:auto!important;width:min(100%,690px)!important;max-width:100%!important}
.agent-portal .agent-portal__request-type-grid--routes{grid-template-columns:repeat(2,minmax(0,1fr))!important;align-items:stretch!important}
.agent-portal .agent-portal__request-type-grid--routes .agent-portal__request-type,.agent-portal .agent-portal__request-type-grid--routes .agent-portal__request-type>span{height:100%!important}
@media(max-width:760px){
  .agent-portal__action-row-v3{grid-template-columns:1fr 1fr}
  .agent-portal__action-row-v3>.agent-portal__actions{grid-column:1/-1;grid-row:2;justify-content:stretch}
  .agent-portal__action-row-v3>.agent-portal__actions button{flex:1}
  .agent-portal__action-row-v3 .agent-portal__draft-status{grid-column:1/-1;grid-row:3}
  .agent-portal.agent-portal--agency-preview .agent-portal__admin-tools{display:grid!important;grid-template-columns:1fr!important;align-items:stretch!important;gap:10px!important}
  .agent-portal.agent-portal--agency-preview .agent-portal__admin-view-control{width:100%!important}
  .agent-portal.agent-portal--agency-preview .agent-portal__admin-view-actions{grid-template-columns:1fr!important;width:100%!important}
  .agent-portal.agent-portal--agency-preview .agent-portal__admin-view-actions select,.agent-portal.agent-portal--agency-preview .agent-portal__admin-return{width:100%!important;min-width:0!important;max-width:100%!important;white-space:normal!important}
}
@media(max-width:640px){
  .agent-portal .agent-portal__request-type-grid--routes{grid-template-columns:1fr!important}
  .agent-portal.agent-portal--agency-preview .agent-portal__tabs.agent-portal__tabs--admin{grid-template-columns:repeat(3,minmax(0,1fr))!important;width:100%!important;border-radius:16px!important;align-items:stretch!important}
  .agent-portal.agent-portal--agency-preview .agent-portal__tabs.agent-portal__tabs--admin .agent-portal__tab{min-height:52px!important;height:auto!important;padding:8px 6px!important;border-radius:12px!important;font-size:1.1rem!important}
  .agent-portal .page-width,
  .agent-portal__hero-inner,
  .agent-portal__layout,
  .agent-portal__workspace,
  .agent-portal__content,
  .agent-portal__portal-nav,
  .agent-portal__tab-panel,
  .agent-portal__status-wrap,
  .agent-portal__status-panel,
  .agent-portal__live-shell,
  .agent-portal__live-table,
  .agent-portal__live-row,
  .agent-portal__ux10-tools,
  .agent-portal__advanced-filters,
  .agent-portal__admin-tools,
  .agent-portal__admin-view-control,
  .agent-portal__admin-view-actions,
  .agent-portal__action-row-v3{min-width:0!important;max-width:100%!important}
  .agent-portal__admin-view-actions>*,
  .agent-portal__live-cell,
  .agent-portal__live-cell>*,
  .agent-portal__identity,
  .agent-portal__ux10-count{min-width:0!important;max-width:100%!important}
  .agent-portal__live-badge{width:fit-content!important;max-width:100%!important;white-space:normal!important;overflow-wrap:anywhere!important}
  .agent-portal__live-open,.agent-portal__ux10-count{white-space:normal!important;overflow-wrap:anywhere!important}
}
`;
    document.head.appendChild(style);
  }

  function syncViewMode(root){
    if(!root)return;
    var select=root.querySelector('[data-admin-view-select]');
    if(!select){
      root.classList.remove('agent-portal--agency-preview','agent-portal--admin-view');
      delete root.dataset.portalViewMode;
      return;
    }
    var agencyPreview=!!select.value&&select.value!=='admetec';
    root.classList.toggle('agent-portal--agency-preview',agencyPreview);
    root.classList.toggle('agent-portal--admin-view',!agencyPreview);
    root.dataset.portalViewMode=agencyPreview?'agency-preview':'admin';

    var copy=root.querySelector('.agent-portal__admin-tools-copy');
    var kicker=copy&&copy.querySelector('.agent-portal__kicker');
    var title=copy&&copy.querySelector(':scope > strong');
    if(kicker)kicker.textContent=agencyPreview?'Voorvertoning agentschap':'Administrator';
    if(title){
      var option=select.options&&select.selectedIndex>=0?select.options[select.selectedIndex]:null;
      var name=option?String(option.textContent||'').trim():'Agentschap';
      title.textContent=agencyPreview?(name||'Agentschap'):'Beheer & controle';
    }

    if(select.dataset.uiCleanupViewMode!=='true'){
      select.dataset.uiCleanupViewMode='true';
      select.addEventListener('change',function(){window.setTimeout(function(){syncViewMode(root)},0)});
    }
    [].slice.call(root.querySelectorAll('[data-admin-return]')).forEach(function(button){
      if(button.dataset.uiCleanupViewMode==='true')return;
      button.dataset.uiCleanupViewMode='true';
      button.addEventListener('click',function(){window.setTimeout(function(){syncViewMode(root)},0)});
    });
  }

  function install(root){
    if(!root)return;
    syncViewMode(root);
    var form=root.querySelector('[data-agent-form]');
    if(!form)return;
    var draftBar=form.querySelector('.agent-portal__draft-bar');
    var actions=form.querySelector('.agent-portal__actions');
    if(!draftBar||!actions)return;
    if(draftBar.closest('.agent-portal__action-row-v3'))return;

    var row=document.createElement('div');
    row.className='agent-portal__action-row-v3';
    draftBar.parentNode.insertBefore(row,draftBar);
    row.appendChild(draftBar);
    row.appendChild(actions);
  }

  function boot(scope){
    ensureStyles();
    var base=scope&&scope.querySelectorAll?scope:document;
    [].slice.call(base.querySelectorAll('.agent-portal[data-agent-portal]')).forEach(install);
  }

  var scheduled=false;
  function schedule(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(function(){scheduled=false;boot(document)});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document)});else boot(document);
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true});
  window.addEventListener('popstate',schedule);
  document.addEventListener('shopify:section:load',function(event){boot(event.target||document)});
})();

/* LEADS_SHARED_CUSTOMER_LOOKUP_V1 — reuse the order-route Shopify customer lookup. */
(function(){
  'use strict';
  if(window.__admetecLeadSharedCustomerLookupV1)return;
  window.__admetecLeadSharedCustomerLookupV1=true;

  var API='/apps/agentenportaal-api/customer-lookup';

  function ensureStyles(){
    if(document.getElementById('AplCustomerLookupV1Styles'))return;
    var style=document.createElement('style');
    style.id='AplCustomerLookupV1Styles';
    style.textContent='.apl-customer-lookup{position:relative}.apl-customer-lookup__results{position:absolute;left:0;right:0;top:calc(100% + 5px);z-index:140;max-height:270px;overflow:auto;padding:5px;border:1px solid #d5d8dd;border-radius:11px;background:#fff;box-shadow:0 14px 34px rgba(20,24,32,.16)}.apl-customer-lookup__option{display:block;width:100%;border:0;border-radius:8px;background:#fff;padding:9px 10px;text-align:left;font:inherit;cursor:pointer}.apl-customer-lookup__option:hover,.apl-customer-lookup__option:focus{outline:0;background:#fff3f5}.apl-customer-lookup__option strong,.apl-customer-lookup__option small{display:block}.apl-customer-lookup__option small{margin-top:2px;color:#70757d;font-size:11px}.apl-customer-lookup__status{display:block;margin-top:6px;color:#70757d;font-size:11px;line-height:1.4}.apl-customer-lookup__status[data-state="found"]{color:#23643a}.apl-customer-lookup__status[data-state="error"]{color:#9b2339}.apl-customer-lookup__status[data-state="loading"]{color:#775b12}.apl-customer-lookup__empty{padding:10px;color:#70757d;font-size:12px}';
    document.head.appendChild(style);
  }

  function request(payload){
    payload=Object.assign({},payload||{},{portalCustomerReuseV1:true});
    return fetch(API,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify(payload)}).then(function(response){
      return response.json().catch(function(){return {}}).then(function(data){
        if(!response.ok||data.ok===false)throw new Error(data.message||data.error||('HTTP '+response.status));
        return data;
      });
    });
  }

  function countryLabel(value){
    var v=String(value||'').trim().toUpperCase();
    if(v==='NL')return 'Nederland';
    if(v==='BE')return 'België';
    return String(value||'').trim();
  }

  function install(form){
    if(!form||form.dataset.aplCustomerLookupReady==='true')return;
    var first=form.querySelector('[data-apl-field="firstName"]');
    var last=form.querySelector('[data-apl-field="lastName"]');
    var email=form.querySelector('[data-apl-field="email"]');
    if(!first||!last||!email)return;
    form.dataset.aplCustomerLookupReady='true';
    ensureStyles();

    var field=document.createElement('div');
    field.className='apl-field apl-field--full';
    field.setAttribute('data-apl-customer-lookup-field','');
    field.innerHTML='<label for="AplCustomerLookupInput">Bestaande Shopify-klant zoeken</label><div class="apl-customer-lookup"><input id="AplCustomerLookupInput" class="apl-input" type="search" autocomplete="off" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="AplCustomerLookupResults" placeholder="Typ minimaal 2 letters van de naam"><div id="AplCustomerLookupResults" class="apl-customer-lookup__results" role="listbox" hidden></div></div><small class="apl-customer-lookup__status" data-state="idle">Zoek eerst in Shopify. Kies een klant om de beschikbare gegevens automatisch in te vullen.</small>';
    var hiddenId=form.querySelector('[data-apl-field="id"]');
    if(hiddenId&&hiddenId.nextSibling)form.insertBefore(field,hiddenId.nextSibling);else form.insertBefore(field,form.firstChild||null);

    var input=field.querySelector('input');
    var results=field.querySelector('[role="listbox"]');
    var status=field.querySelector('.apl-customer-lookup__status');
    var timer=null;
    var emailTimer=null;
    var sequence=0;
    var emailSequence=0;
    var muted=false;
    var selectedEmail='';

    function leadField(name){return form.querySelector('[data-apl-field="'+name+'"]')}
    function setStatus(text,state){status.textContent=text;status.setAttribute('data-state',state||'idle')}
    function fire(node){node.dispatchEvent(new Event('input',{bubbles:true}));node.dispatchEvent(new Event('change',{bubbles:true}))}
    function put(name,value,force){
      var node=leadField(name);var text=String(value==null?'':value).trim();
      if(!node||!text)return;
      if(!force&&String(node.value||'').trim())return;
      node.value=text;muted=true;try{fire(node)}finally{muted=false}
    }
    function apply(customer,force){
      if(!customer)return;
      put('firstName',customer.firstName,force);
      put('lastName',customer.lastName,force);
      put('company',customer.company,force);
      put('email',customer.email,force);
      put('phone',customer.phone,force);
      put('city',customer.city,force);
      put('country',countryLabel(customer.country),force);
      selectedEmail=String(customer.email||'').trim().toLowerCase();
    }
    function close(){results.hidden=true;input.setAttribute('aria-expanded','false')}
    function choose(customer){
      sequence+=1;emailSequence+=1;apply(customer,true);input.value=customer.name||[customer.firstName,customer.lastName].filter(Boolean).join(' ');close();
      setStatus('Bestaande Shopify-klant geselecteerd. De beschikbare klantgegevens zijn ingevuld en worden bij opslaan opnieuw server-side gecontroleerd.','found');
    }
    function show(customers){
      results.innerHTML='';
      if(!customers.length){var empty=document.createElement('div');empty.className='apl-customer-lookup__empty';empty.textContent='Geen bestaande Shopify-klant gevonden.';results.appendChild(empty)}
      customers.forEach(function(customer){
        var button=document.createElement('button');button.type='button';button.className='apl-customer-lookup__option';button.setAttribute('role','option');
        var strong=document.createElement('strong');strong.textContent=customer.name||[customer.firstName,customer.lastName].filter(Boolean).join(' ')||customer.email||'Shopify-klant';
        var small=document.createElement('small');small.textContent=[customer.company,customer.city,customer.email].filter(Boolean).join(' · ');
        button.appendChild(strong);button.appendChild(small);button.addEventListener('mousedown',function(event){event.preventDefault()});button.addEventListener('click',function(){choose(customer)});results.appendChild(button);
      });
      results.hidden=false;input.setAttribute('aria-expanded','true');
    }
    function search(){
      var value=String(input.value||'').trim();
      if(value.replace(/\s/g,'').length<2){close();setStatus('Typ minimaal 2 letters om een bestaande Shopify-klant te zoeken.','idle');return}
      var current=++sequence;setStatus('Bestaande Shopify-klanten zoeken…','loading');
      request({mode:'search-customers',name:value}).then(function(data){
        if(current!==sequence)return;var customers=Array.isArray(data.customers)?data.customers:[];show(customers);setStatus(customers.length?(customers.length+' '+(customers.length===1?'klant':'klanten')+' gevonden. Kies de juiste Shopify-klant.'):'Geen bestaande Shopify-klant gevonden op deze naam.',customers.length?'found':'idle');
      }).catch(function(error){if(current!==sequence)return;close();if(window.console&&console.warn)console.warn('[Agentenportaal] lead klantzoeken mislukt',error);setStatus('Zoeken is tijdelijk niet beschikbaar. Je kunt de lead handmatig invoeren.','error')});
    }
    function lookupEmail(){
      var value=String(email.value||'').trim().toLowerCase();
      if(!value||!email.checkValidity()||value===selectedEmail)return;
      var current=++emailSequence;setStatus('Bestaande Shopify-klant controleren via e-mail…','loading');
      request({mode:'lookup-customer',email:value}).then(function(data){
        if(current!==emailSequence)return;
        if(data.found&&data.customer){apply(data.customer,false);setStatus('Bestaande Shopify-klant gevonden via e-mail. Lege klantvelden zijn aangevuld.','found')}
        else if(data.found){setStatus('Dit e-mailadres hoort bij een portaalaccount en kan niet als eindklant worden gebruikt.','error')}
        else{setStatus('Geen bestaande Shopify-klant gevonden. Deze lead kan als nieuwe relatie worden opgeslagen.','idle')}
      }).catch(function(error){if(current!==emailSequence)return;if(window.console&&console.warn)console.warn('[Agentenportaal] lead e-mailcontrole mislukt',error);setStatus('Klantcontrole tijdelijk niet beschikbaar; bij opslaan controleert de backend opnieuw.','error')});
    }
    function resetLookup(){
      sequence+=1;emailSequence+=1;window.clearTimeout(timer);window.clearTimeout(emailTimer);input.value='';selectedEmail='';close();setStatus('Zoek eerst in Shopify. Kies een klant om de beschikbare gegevens automatisch in te vullen.','idle');
    }

    input.addEventListener('input',function(){selectedEmail='';window.clearTimeout(timer);timer=window.setTimeout(search,350)});
    input.addEventListener('focus',function(){if(String(input.value||'').trim().replace(/\s/g,'').length>=2&&results.childNodes.length){results.hidden=false;input.setAttribute('aria-expanded','true')}});
    email.addEventListener('input',function(){if(muted)return;selectedEmail='';window.clearTimeout(emailTimer);emailTimer=window.setTimeout(lookupEmail,650)});
    email.addEventListener('blur',function(){if(muted)return;window.clearTimeout(emailTimer);lookupEmail()});
    document.addEventListener('mousedown',function(event){if(!field.contains(event.target))close()});

    var modal=form.closest('[data-apl-modal]');
    if(modal&&window.MutationObserver){
      var wasOpen=modal.classList.contains('is-open');
      new MutationObserver(function(){var open=modal.classList.contains('is-open');if(open&&!wasOpen)resetLookup();wasOpen=open}).observe(modal,{attributes:true,attributeFilter:['class','aria-hidden']});
    }
  }

  function scan(){Array.prototype.slice.call(document.querySelectorAll('[data-apl-form]')).forEach(install)}
  var queued=false;
  function schedule(){if(queued)return;queued=true;window.requestAnimationFrame(function(){queued=false;scan()})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',schedule);
})();
